import React from 'react';
import { Grid } from 'semantic-ui-react';
import EmailSender from './EmailSender';
import EmailIntegrations from './EmailIntegrations';
import EmailPreferences from './EmailPreferences';
import { useSelector } from 'react-redux';
import { USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';

const Email = () => {
    const active = useSelector((state) =>
        state.user.userProfile.active
    )
    return (
        <RestrictedView userPermission={USER_PERMISSIONS.USER_PROFILE_PREFERENCES_VIEW} type="restricted" userRestrict>
            <Grid>
                <Grid.Row>
                    <Grid.Column>
                        <EmailSender active={active} />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <EmailIntegrations active={active}/>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <EmailPreferences active={active}/>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </RestrictedView>
    )
};

export default Email;
